import React from 'react';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';

const useStyles = makeStyles((theme) => ({
    gradientButton: {
        background: 'linear-gradient(to right, #095179, #61cccc)',
        borderRadius: '15px',
        color: 'white',
        fontWeight: 'bold',
        position: 'fixed',
        bottom: '0.5vh', // 5% da altura da janela
        right: '0.5vw',  // 5% da largura da janela
        '&:hover': {
            background: 'linear-gradient(to right, #003f81, #388E3C)',
        },
    },
    typography: {
        fontSize: '14px',
        textTransform: 'none', // Evita a transformação para maiúsculas
        marginRight: '50px',
        marginLeft: '10px',
        fontFamily: 'Montserrat, sans-serif',
        fontWeight: 'bold'
    },
    circleIconContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#00cc46', // Cor de fundo verde para o círculo
        width: '33px', // Largura do círculo
        height: '33px', // Altura do círculo
        borderRadius: '50%', // Bordas arredondadas para criar um círculo
        bottom: '2vh',
        right: '0.5vw',
        position: 'fixed'
    },
    whatsappIcon: {
        fontSize: '70px',
        color: 'white', // Cor do ícone do WhatsApp
    }
}));

const handleWhatsAppClick = () => {
    // Abra o link em uma nova guia
    window.open('https://api.whatsapp.com/send/?phone=5561996894936&text&type=phone_number&app_absent=0');
};


function WhatsAppButton() {
    const classes = useStyles();

    return (
        <>
            <Button className={classes.gradientButton} onClick={handleWhatsAppClick}>
                <Typography className={classes.typography}>
                    Converse com nosso suporte pelo WhatsApp
                </Typography>
            </Button>
            <div className={classes.circleIconContainer} onClick={handleWhatsAppClick}>
                <WhatsAppIcon className={classes.whatsappIcon} style={{ fontSize: '50px' }} />
            </div>
            {/* <WhatsAppIcon style={{ fontSize: '50px', color: 'green', bottom: '0.2vh', right: '0.1vw', position: 'fixed' }} /> */}


        </>
    );
}

export default WhatsAppButton;
